import { render, staticRenderFns } from "./FaturaCiktisiButon2.vue?vue&type=template&id=470411de&"
import script from "./FaturaCiktisiButon2.vue?vue&type=script&lang=js&"
export * from "./FaturaCiktisiButon2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports